import { manageEpisodeActionTypes } from '@/admin/components/modals/manageEpisodeModal/Constants';

import type {
	Episode,
	ManageEpisodeRequestPayload,
	ToggleManageEpisodeModalPayload,
} from '@/admin/components/modals/manageEpisodeModal/types';

export interface ToggleManageEpisodeModalAction {
	type: typeof manageEpisodeActionTypes.TOGGLE_MANAGE_EPISODE_MODAL;
	payload: ToggleManageEpisodeModalPayload;
}

export interface GetEpisodeDataRequestAction {
	type: typeof manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_REQUEST;
	payload: { episodeId: number };
}

export interface GetEpisodeDataSuccessAction {
	type: typeof manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_SUCCESS;
	payload: { episodeData: Episode };
}

export interface GetEpisodeDataErrorAction {
	type: typeof manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_ERROR;
}

export interface ManageEpisodeRequestAction {
	type: typeof manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_REQUEST;
	payload: ManageEpisodeRequestPayload;
}

export interface ManageEpisodeSuccessAction {
	type: typeof manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_SUCCESS;
}

export interface ManageEpisodeErrorAction {
	type: typeof manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_ERROR;
}

export interface CleanManageEpisodeStateAction {
	type: typeof manageEpisodeActionTypes.CLEAN_MANAGE_EPISODE_STATE;
}

export type ManageEpisodeActions =
	| ToggleManageEpisodeModalAction
	| GetEpisodeDataRequestAction
	| GetEpisodeDataSuccessAction
	| GetEpisodeDataErrorAction
	| ManageEpisodeRequestAction
	| ManageEpisodeSuccessAction
	| ManageEpisodeErrorAction
	| CleanManageEpisodeStateAction;

export function toggleEpisodeManageModal(
	payload: ToggleManageEpisodeModalPayload,
): ToggleManageEpisodeModalAction {
	return {
		type: manageEpisodeActionTypes.TOGGLE_MANAGE_EPISODE_MODAL,
		payload,
	};
}

export function getEpisodeDataRequest(episodeId: number): GetEpisodeDataRequestAction {
	return {
		type: manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_REQUEST,
		payload: { episodeId },
	};
}

export function getEpisodeDataSuccess(episodeData: Episode): GetEpisodeDataSuccessAction {
	return {
		type: manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_SUCCESS,
		payload: { episodeData },
	};
}

export function getEpisodeDataError(): GetEpisodeDataErrorAction {
	return {
		type: manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_ERROR,
	};
}

export function manageEpisodeRequest(
	payload: ManageEpisodeRequestPayload,
): ManageEpisodeRequestAction {
	return {
		type: manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_REQUEST,
		payload,
	};
}

export function manageEpisodeSuccess(): ManageEpisodeSuccessAction {
	return {
		type: manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_SUCCESS,
	};
}

export function manageEpisodeError(): ManageEpisodeErrorAction {
	return {
		type: manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_ERROR,
	};
}

export function cleanManageEpisodeState(): CleanManageEpisodeStateAction {
	return {
		type: manageEpisodeActionTypes.CLEAN_MANAGE_EPISODE_STATE,
	};
}
